import type TableView from '../store/schema/TableView';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * Clears both row-key and group-header selection on a table view.
 */
export default function clearSelection(tableView: TableView): void {
    tableView.selectedRowKeys.clear();
    tableView.selectedGroupHeaders.clear();
    if (isGlobalFeatureEnabled('tri-mlCheckboxBehavior')) {
        // The anchor only has meaning relative to a selection, so drop it too.
        tableView.multiSelectionAnchorRowKey = null;
    }
}
